type ItemPriceRequestEntry = { itemNo?: string; itemId: string | number };

declare global {
    interface Window {
        __BASE_URL?: string;
    }
}

const BASE =
    (typeof window !== "undefined" && window.__BASE_URL) ? window.__BASE_URL : "";

function buildEndpoint(): string {
    const siteCode = typeof document !== "undefined" ? document.body.dataset.site_code : undefined;
    const languageCode = typeof document !== "undefined" ? document.body.dataset.lang_code : undefined;

    const params = new URLSearchParams({ function: "getAlgoliaItemListRender" });
    if (siteCode) params.set("site", siteCode);
    if (languageCode) params.set("language", languageCode);

    return `${BASE}/module/dcshop/b2c/ajax.php?${params.toString()}`;
}

function isLoggedIn(): boolean {
    return typeof document !== "undefined" && document.body.classList.contains("isLoggedIn");
}

export async function fetchItemListPrices(
    items: ItemPriceRequestEntry[]
): Promise<Record<string, PriceData>> {
    if (typeof window === "undefined" || !items.length) return {};

    // Guests always see the price baked into the Algolia index - only logged-in
    // customers can have debitor-specific pricing, so skip the request entirely.
    if (!isLoggedIn()) return {};

    try {
        const res = await fetch(buildEndpoint(), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ item_list: items }),
        });

        const text = await res.text();
        try {
            return JSON.parse(text) as Record<string, PriceData>;
        } catch {
            return {};
        }
    } catch {
        return {};
    }
}
